import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { EcosystemListingCard } from 'trellis-ecosystem';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { NoResults } from './NoResults';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid() {
  const {
    loading,
    data,
    error
  } = useSearchResultsQuery();
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "800"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  if ((data === null || data === void 0 ? void 0 : data.result.total) === 0) {
    return /*#__PURE__*/_jsx(NoResults, {});
  }
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: 300,
    gap: "600",
    children: data === null || data === void 0 ? void 0 : data.result.cards.map((listing, index) => {
      var _listing$listingName, _listing$providerName, _listing$description, _listing$slug;
      return /*#__PURE__*/_jsx(EcosystemListingCard, {
        name: (_listing$listingName = listing.listingName) !== null && _listing$listingName !== void 0 ? _listing$listingName : '',
        providerName: (_listing$providerName = listing.providerName) !== null && _listing$providerName !== void 0 ? _listing$providerName : '',
        description: (_listing$description = listing.description) !== null && _listing$description !== void 0 ? _listing$description : '',
        listingHref: (_listing$slug = listing.slug) !== null && _listing$slug !== void 0 ? _listing$slug : '',
        imageSrcSmall: listing.iconUrl
      }, `listing-${index}`);
    })
  });
}